// Parallel HubSpot submission for the PDP's "Contact Us About
// This Product" form (#ProductContactForm, sections/main-product.liquid).
// The <contact-form> custom element wrapping this markup is not defined
// anywhere in the theme's JS (confirmed by grep across assets/) -- an
// undefined custom element behaves as an inert wrapper, so this really is
// a plain native {% form 'contact' %} submission, not JS-intercepted like
// the "Email for Price" flow (assets/global.js's ProductEmailForm).
//
// Confirmed active render path: sections/main-product.liquid:465, the
// default product template's own section, used by every product page.
// Three alternate product templates also contain a literal duplicate of
// this same #ProductContactForm markup (templates/product.email-for-price.liquid,
// templates/product.lead-time.liquid, templates/product.gift-card.liquid)
// -- these are Shopify alternate templates that only apply if a merchant
// explicitly assigns one to a specific product, and none were confirmed
// actually assigned to any live product. Not wired to this script in
// this pass -- flagged as a possible follow-up if any of those templates
// turn out to be in active use, rather than assumed either way.
//
// Routed through the same-origin form relay (Shopify App Proxy ->
// nella-app-proxy -> Linen Plus Middleware -> HubSpot), not a direct
// client-side call to api.hsforms.com -- confirmed blocked by ad
// blockers/tracking protection on a real visitor's browser. See
// docs/testing/form-relay-strategy.html.
(function () {
  const RELAY_URL = '/apps/nella-app-login/forms/product_contact';
  const FORM_TOKEN_URL = '/apps/nella-app-login/forms-token';

  const formEl = document.getElementById('ProductContactForm');
  if (!formEl) return;
  if (formEl.dataset.hubspotWired) return;
  formEl.dataset.hubspotWired = 'true';

  // This form has one combined "Name" field, but HubSpot's own UI is
  // built around the standard firstname/lastname properties -- same
  // rationale and same first-space split as every other HubSpot
  // integration in this project.
  function splitName(fullName) {
    const trimmed = (fullName || '').trim().replace(/\s+/g, ' ');
    if (!trimmed) return { firstName: '', lastName: '' };
    const spaceIndex = trimmed.indexOf(' ');
    if (spaceIndex === -1) return { firstName: trimmed, lastName: '' };
    return { firstName: trimmed.slice(0, spaceIndex), lastName: trimmed.slice(spaceIndex + 1) };
  }

  // Reuses requested_product_sku / requested_product_title (created for
  // the Email for Price integration) and contact_message (created for
  // Contact Us) rather than inventing new properties -- this form
  // represents the same underlying concept ("a customer asking about
  // product X") as those, just through a different entry point, so no
  // new HubSpot properties are needed for this integration, only a new
  // form mapping the ones that already exist.
  function buildHubSpotFields() {
    const fields = [];
    const push = (name, value) => {
      const v = (value ?? '').toString().trim();
      if (v) fields.push({ name, value: v });
    };
    const byId = (id) => (document.getElementById(id)?.value || '').toString().trim();
    const { firstName, lastName } = splitName(byId('ContactForm-name--product'));

    push('email', byId('ContactForm-email--product'));
    push('firstname', firstName);
    push('lastname', lastName);
    push('contact_message', byId('ContactForm-body--product'));
    push('requested_product_sku', byId('sku--product'));
    push('requested_product_title', byId('product_title--product'));
    push('inquiry_source', 'Product Contact');

    return fields;
  }

  // Fetched up front and refreshed periodically, not at submit time: this
  // native form navigates away immediately on submit (no preventDefault
  // below), which tears down this script's JS context before a token
  // fetched right then could reliably resolve -- `keepalive` only protects
  // an already-sent request, not a `.then()` waiting to send a second one
  // after it. A pre-fetched token keeps submit time down to that one
  // keepalive request.
  const FORM_TOKEN_REFRESH_MS = 5 * 60 * 1000; // server TTL is 10 min; refresh with margin
  let cachedFormToken = null;

  function fetchFormToken() {
    return fetch(FORM_TOKEN_URL)
      .then((r) => r.json())
      .then((data) => (data && data.token) || null)
      .catch(() => null);
  }

  function refreshFormToken() {
    fetchFormToken().then((token) => { cachedFormToken = token; });
  }

  refreshFormToken();
  setInterval(refreshFormToken, FORM_TOKEN_REFRESH_MS);

  function submitToHubSpot() {
    try {
      const payload = {
        fields: buildHubSpotFields(),
        pageUri: window.location.href,
        pageName: document.title,
      };
      fetch(RELAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, formToken: cachedFormToken }),
        keepalive: true,
      }).catch((err) => console.warn('HubSpot relay failed (Shopify submission is unaffected):', err));
    } catch (err) {
      console.warn('HubSpot relay failed (Shopify submission is unaffected):', err);
    }
  }

  // Fire on submit, never block it. This form has no custom JS validation
  // beyond native HTML5 constraints, so by the time a 'submit' event
  // reaches here the browser has already accepted the input as valid.
  formEl.addEventListener('submit', () => {
    submitToHubSpot();
  });
})();
